// extracted by mini-css-extract-plugin
module.exports = {"title":"delete-cookies-section_title__c64M9"};